import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map } from 'lodash';
import classnames from 'classnames';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { ActionWidgetActivity } from 'ui/containers/ActionWidgetActivity';
import { ActionWidgetNotes } from 'ui/containers/ActionWidgetNotes';

const WIDGET_VIEWS = {
    [ WIDGET_NAMES.ACTION_DETAIL_TABS_INNER_WIDGET_ACTIVITY ]: ActionWidgetActivity,
    [ WIDGET_NAMES.ACTION_DETAIL_TABS_INNER_WIDGET_NOTES ]: ActionWidgetNotes
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionItemDetailInnerWidget as ActionItemDetailInnerWidget } from 'ui/views/widgets/actionItemDetailInnerWidget';
 *
 * // render
 * <ActionItemDetailInnerWidget propName='propValue'/>
 */
export const actionItemDetailInnerWidgetSuccess = ( props ) => {
    
    return (
        <div className='ui-action-item-detail-inner-widget'>
                {
                    map( props.widgets, widget => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        const widgetClassName = classnames( 'ui-action-item-detail-inner-widget__widget', `ui-action-item-detail-inner-widget__widget--name-${ widget.name }` );

                        return (
                            <div key={ widget.name } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    actionId={ props.actionId }
                                    requestPayload={ props.requestPayload }
                                 />
                            </div>
                        );
                    } )
                }
        </div>
    );
};

// set display name
actionItemDetailInnerWidgetSuccess.displayName = 'actionItemDetailInnerWidgetSuccess';

// set default props
actionItemDetailInnerWidgetSuccess.defaultProps = {};

// prop types
actionItemDetailInnerWidgetSuccess.propTypes = {};

// Preloader view
export const actionItemDetailInnerWidgetPreloader = () => {
    return (
           <div className='ui-action-item-detail-inner-widget__pagination-spinner'>
               
                <WidgetPreloader />
            </div>
    );
};

// set display name
actionItemDetailInnerWidgetPreloader.displayName = 'actionItemDetailInnerWidgetPreloader';

// set default props
actionItemDetailInnerWidgetPreloader.defaultProps = {};

// prop types
actionItemDetailInnerWidgetPreloader.propTypes = {};

export const actionItemDetailInnerWidget = withNetworkState( actionItemDetailInnerWidgetPreloader, actionItemDetailInnerWidgetSuccess );
